import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const restoreSkillMap = api(async function restoreSkillMap({ id }) {
    return mutate(
        gql`
            mutation RestoreSkillMap($id: String!) {
                restoreSkillMap(id: $id)
            }
        `,
        { id },
        { returns: "restoreSkillMap" }
    )
})
